import * as Sentry from '@sentry/react';
import React from 'react';
import { WebAppCam } from './components/WebAppCam/WebAppCam';
import styles from './styles.module.sass';

export const App: React.FC = () => {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div className={styles.errorContainer}>
          <div className={styles.errorCard}>
            <h2 className={styles.errorTitle}>Что-то пошло не так...</h2>
            <p className={styles.errorMessage}>
              {error instanceof Error ? error.message : String(error)}
            </p>
            <button onClick={resetError} className={styles.retryButton}>
              Попробовать снова
            </button>
          </div>
        </div>
      )}
    >
      <WebAppCam />
    </Sentry.ErrorBoundary>
  );
};
